import React, { useState, useEffect } from 'react';
import { Monitor, Smartphone } from 'lucide-react';
import './ViewToggle.css';

const ViewToggle = () => {
    const [isDesktopView, setIsDesktopView] = useState(() => {
        // Check localStorage for saved preference, default to true (desktop)
        const saved = localStorage.getItem('viewMode');
        return saved ? saved === 'desktop' : true; // Default to desktop view
    });

    useEffect(() => {
        const viewport = document.querySelector('meta[name="viewport"]');

        if (isDesktopView) {
            // Desktop view: fixed width
            if (viewport) {
                viewport.setAttribute('content', 'width=1200, initial-scale=0.5, user-scalable=yes');
            }
            document.body.classList.add('force-desktop-view');
            localStorage.setItem('viewMode', 'desktop');
        } else {
            // Mobile view: responsive
            if (viewport) {
                viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=5.0, user-scalable=yes');
            }
            document.body.classList.remove('force-desktop-view');
            localStorage.setItem('viewMode', 'mobile');
        }
    }, [isDesktopView]);

    // Only show toggle on mobile/tablet devices
    const [isMobileDevice, setIsMobileDevice] = useState(window.innerWidth < 1024);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileDevice(window.innerWidth < 1024);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (!isMobileDevice) return null;

    return (
        <button
            className="view-toggle-button"
            onClick={() => setIsDesktopView(!isDesktopView)}
            aria-label={isDesktopView ? "Switch to mobile view" : "Switch to desktop view"}
            title={isDesktopView ? "Switch to mobile view" : "Switch to desktop view"}
        >
            {isDesktopView ? (
                <>
                    <Smartphone size={18} />
                    <span>Mobile View</span>
                </>
            ) : (
                <>
                    <Monitor size={18} />
                    <span>Desktop View</span>
                </>
            )}
        </button>
    );
};

export default ViewToggle;